import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const MONTHS = [
  ["01", "January"], ["02", "February"], ["03", "March"], ["04", "April"],
  ["05", "May"], ["06", "June"], ["07", "July"], ["08", "August"],
  ["09", "September"], ["10", "October"], ["11", "November"], ["12", "December"],
];

// Manual date-of-birth entry (Day input + Month dropdown + Year input).
// value / onChange use an ISO "YYYY-MM-DD" string. Emits "" until all parts are set.
export default function DobField({ value = "", onChange, testid = "dob" }) {
  const [d, setD] = useState("");
  const [m, setM] = useState("");
  const [y, setY] = useState("");

  useEffect(() => {
    if (value && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [yy, mm, dd] = value.split("-");
      setY(yy); setM(mm); setD(String(Number(dd)));
    }
  }, [value]);

  const emit = (nd, nm, ny) => {
    if (nd && nm && ny && ny.length === 4) onChange(`${ny}-${nm}-${String(nd).padStart(2, "0")}`);
    else onChange("");
  };
  const onDay = (e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 2); setD(v); emit(v, m, y); };
  const onYear = (e) => { const v = e.target.value.replace(/\D/g, "").slice(0, 4); setY(v); emit(d, m, v); };
  const onMonth = (v) => { setM(v); emit(d, v, y); };

  return (
    <div className="grid grid-cols-3 gap-2 mt-1.5" data-testid={testid}>
      <Input inputMode="numeric" placeholder="Day" value={d} onChange={onDay} className="h-11" data-testid={`${testid}-day`} />
      <Select value={m} onValueChange={onMonth}>
        <SelectTrigger className="h-11" data-testid={`${testid}-month`}><SelectValue placeholder="Month" /></SelectTrigger>
        <SelectContent className="max-h-64">{MONTHS.map(([val, name]) => <SelectItem key={val} value={val}>{name}</SelectItem>)}</SelectContent>
      </Select>
      <Input inputMode="numeric" placeholder="Year" value={y} onChange={onYear} className="h-11" data-testid={`${testid}-year`} />
    </div>
  );
}
